import { render, staticRenderFns } from "./NewOQCdata.vue?vue&type=template&id=76e9bfd4&scoped=true"
import script from "./NewOQCdata.vue?vue&type=script&lang=js"
export * from "./NewOQCdata.vue?vue&type=script&lang=js"
import style0 from "./NewOQCdata.vue?vue&type=style&index=0&id=76e9bfd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e9bfd4",
  null
  
)

export default component.exports